import _asyncToGenerator from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */
var userAgentMiddlewareFactory = function userAgentMiddlewareFactory(_ref) {
  var _ref$userAgentHeader = _ref.userAgentHeader,
      userAgentHeader = _ref$userAgentHeader === void 0 ? 'x-amz-user-agent' : _ref$userAgentHeader,
      _ref$userAgentValue = _ref.userAgentValue,
      userAgentValue = _ref$userAgentValue === void 0 ? '' : _ref$userAgentValue;
  return function (next) {
    return /*#__PURE__*/function () {
      var _userAgentMiddleware = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var result, headerName, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(userAgentValue.trim().length === 0)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return next(request);

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result);

              case 7:
                headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? "".concat(request.headers[headerName], " ").concat(userAgentValue) : userAgentValue;
                _context.next = 11;
                return next(request);

              case 11:
                response = _context.sent;
                return _context.abrupt("return", response);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function userAgentMiddleware(_x) {
        return _userAgentMiddleware.apply(this, arguments);
      }

      return userAgentMiddleware;
    }();
  };
};

export { userAgentMiddlewareFactory };